"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const _1 = require(".");
const hooks_1 = require("../../hooks");
exports.AppIsReady = () => {
    const { updateOsmosysContext } = hooks_1.useOsmosysUpdate();
    const { appHasLoaded, appSettings } = hooks_1.useOsmosysContext();
    react_1.useEffect(() => {
        if (!!appSettings && !appHasLoaded) {
            const t = setTimeout(() => {
                updateOsmosysContext({
                    appHasLoaded: true,
                });
                window.osmosysHasLoaded = true;
            }, _1.LOAD_DELAY);
            return () => {
                clearTimeout(t);
            };
        }
        return () => { };
    }, [appHasLoaded, appSettings]);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
//# sourceMappingURL=AppIsReady.js.map